/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_Download_FailedInputs */

const vi_einvoice_error_preview_download_failed = /** @type {(inputs: Einvoice_Error_Preview_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được file xem trước hóa đơn từ MISA. Vui lòng thử lại sau.`)
};

/**

* @param {Einvoice_Error_Preview_Download_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_download_failed = /** @type {((inputs?: Einvoice_Error_Preview_Download_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_Download_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_download_failed(inputs)
});